const getGlobalFormat = () => {
  return localStorage.getItem("dateFormat") || "MM/DD/YYYY";
};

export const formatDate = (date, format) => {
  if (!date || date === "-" || date === "Invalid Date") return "-";

  const finalFormat = format || getGlobalFormat();
  const d = new Date(date);

  const day = d.getDate();       
  const month = d.getMonth() + 1; 
  const year = d.getFullYear();

  switch (finalFormat) {
    case "DD/MM/YYYY":
      return `${day}/${month}/${year}`;

    case "MM/DD/YYYY":
      return `${month}/${day}/${year}`;

    case "YYYY-MM-DD":
      return `${year}-${month}-${day}`;

    default:
      return `${month}/${day}/${year}`;
  }
};

export const formatDateTime = (date, format) => {
  if (!date) return "-";

  const finalFormat = format || getGlobalFormat();

  const formattedDate = formatDate(date, finalFormat);
  const d = new Date(date);

  const hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM"; 
  const hour12 = hours % 12 || 12;

  return `${formattedDate}, ${hour12}:${minutes} ${ampm}`;
};

export const formatDateRange = (range, format) => {
  if (!range) return "-";

  const finalFormat = format || getGlobalFormat();

  const parts = range.split(" - ");
  if (parts.length !== 2) return range;

  const [start, end] = parts;

  return `${formatDate(start, finalFormat)} - ${formatDate(end, finalFormat)}`;
};

export const getDateBoxFormat = () => {
  const format = getGlobalFormat();

  return format
    .replace("DD", "d")     
    .replace("MM", "M")   
    .replace("YYYY", "yyyy");
};